<div class="custom_card mt-4">
  <div class="card_header">
    <h4>
      {{'rights.repliesAndComments'|translate}}
    </h4>
  </div>
  <div class="card_body">
    <ul class="list_feedbacks_comments" *ngIf="comments && comments.length">
      <li *ngFor="let item of comments">
        <ng-container *ngTemplateOutlet="commentList,context:{comment:item}">
        </ng-container>
      </li>
      <div *ngIf="commentsLoading" class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>
    </ul>
    <app-comment-controls (submitComment)="submitComment($event )"></app-comment-controls>
  </div>
</div>
<ng-template #commentList let-comment="comment">
  <div class="feedback_container">
    <div class="feedback_body">
      <div class="feedback_thumbnail">
        <img *ngIf="comment.userImage" [src]="comment.userImage" (error)='comment.userImage = ""'>
        <span *ngIf="!comment.userImage">
          {{ comment.commentedBy| shortName }}
        </span>
      </div>
      <div class="feedback_content">
        <div class="auther_name">
          {{ comment.commentedBy }}
          <!-- <span class="auther_role">
            {{ comment.creatorRole }}
          </span> -->
        </div>
        <div class="date_time">
          {{comment.commentedDate | date:'d MMM yyyy - h:mm a'}}
        </div>
        <p class="feedback_desc" *ngIf="comment.comment" [innerText]="comment.comment"> </p>

      </div>

      <div class="actions" *ngIf="selectedComment?.id != comment.id">
        <button mat-icon-button *ngIf="comment.canUpdate" (click)="selectedComment = comment;">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16.002" viewBox="0 0 16 16.002">
            <path id="edit"
              d="M134.27-844.586l-3.721-3.683,1.226-1.227a1.68,1.68,0,0,1,1.237-.5,1.68,1.68,0,0,1,1.237.5l1.226,1.227a1.739,1.739,0,0,1,.525,1.217,1.586,1.586,0,0,1-.482,1.217ZM120.875-834a.846.846,0,0,1-.624-.252.849.849,0,0,1-.252-.625v-2.477a.907.907,0,0,1,.066-.34.876.876,0,0,1,.2-.3l9.017-9.031L133-843.292l-9.017,9.031a.875.875,0,0,1-.3.2.9.9,0,0,1-.339.066Z"
              transform="translate(-120 850)" fill="#6b6d85" />
          </svg>
        </button>
        <button mat-icon-button *ngIf="comment.canDelete" (click)="deleteComment(comment)">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18">
            <path id="ic_delete"
              d="M56.917,3H54.592a3.757,3.757,0,0,0-3.675-3h-1.5a3.757,3.757,0,0,0-3.675,3H43.417a.75.75,0,0,0,0,1.5h.75v9.75A3.755,3.755,0,0,0,47.917,18h4.5a3.755,3.755,0,0,0,3.75-3.75V4.5h.75a.75.75,0,0,0,0-1.5Zm-7.5,9.75a.75.75,0,0,1-1.5,0V8.25a.75.75,0,1,1,1.5,0v4.5Zm3,0a.75.75,0,0,1-1.5,0V8.25a.75.75,0,1,1,1.5,0ZM47.3,3a2.255,2.255,0,0,1,2.122-1.5h1.5A2.255,2.255,0,0,1,53.039,3Z"
              transform="translate(-42.667)" fill="#dc3545" />
          </svg>

        </button>
      </div>
    </div>
  </div>


  <app-price-monitoring-tasks-comments-control *ngIf="selectedComment && selectedComment.id == comment.id"
    (cancelEdit)="selectedComment = null" [selectedRecord]="selectedComment"
    (submitComment)="submitComment($event)"></app-price-monitoring-tasks-comments-control>

</ng-template>
